export default __webpack_public_path__ + "static/media/ebay.a6196679.svg";